import React from "react";
import { dateFormatter } from "../../../components/tables/table";

const ProductFamilyContent = ({ family }) => {
	if (!family) return <></>;
	return (
		<>
			<div className="row d-flex align-items-center">
				<div className="col-12">
					<h5>Descripción</h5>
					<p>{family?.descripcion}</p>
				</div>
				<div className="col-12">
					<h5>Referencia</h5>
					<p>{family?.referencia || "---"}</p>
				</div>
			</div>
			<div className="row d-flex align-items-center">
				<div className="col">
					<h5>Fecha Alta</h5>
					<p>{dateFormatter(family?.fecha_alta) + "h"}</p>
				</div>
			</div>
		</>
	);
};

export default ProductFamilyContent;
